import React from 'react';
import UppyDashboard from '@a2d24/uppy';

const PhotoUploader = ({onPhotoCapture, getFacialRecognitionPresignedUrl}) => {
    const maxFileSize = 5
    const onAfterUpload = async (file, plugin) => {
        plugin.uppy.emit('postprocess-progress', file, {
            mode: 'indeterminate',
            message: 'Processing photo...',
        });
        plugin.uppy.setFileState(file.id, {
            meta: {
                ...file.meta,
            },
        });
        if (onPhotoCapture) {
            const s3Url = file.uploadURL || file.meta.key;
            onPhotoCapture(s3Url);
        }
    };

    return (
        <UppyDashboard
            s3PreSignAdapter={(file) => {
                return getFacialRecognitionPresignedUrl(file)
            }}
            plugins={[]}
            height="calc(85vh - 375px)"
            width={'100%'}
            onAfterUpload={onAfterUpload}
            showRemoveButtonAfterComplete={true}
            enableWebcam={true}
            options={{
                autoProceed: false,
                hideAfterFinish: true,
                restrictions: {
                    maxFileSize: maxFileSize * 1024 * 1024,
                    allowedFileTypes: ['image/*'],
                    maxNumberOfFiles: 1,
                },
            }}
            hideProgressAfterFinish={true}
            maxFileSize={maxFileSize}
        />
    );
};

export default PhotoUploader;
